export default {
    '1_month_ago': "менше 1 місяця",
    '12_months_ago': "менше 12 місяців",
    '3_months_ago': "менше 3 місяців",
    '6_months_ago': "менше 6 місяців",
    above_1_month: "більше 1 місяця",
    above_1_year: "більше 1 року",
    above_2_months: "більше 2 місяців",
    above_3_months: "більше 3 місяців",
    above_6_months: "більше 6 місяців",
    add_patients: "Додати пацієнтів",
    add_standard: "Додати стандартні",
    after_one_day: "Через день",
    after_service: "Після отримання послуги",
    agreement_to_get_notifications_in_max: "Згода на отримання сповіщень у Макс",
    all_statuses: "Всі статуси",
    amount_of_patients: "Кількість пацієнтів",
    april: "Квітень",
    are_you_sure_you_want_to_delete_mailing: "Ви впевнені, що хочете видалити розсилку?",
    august: "Серпень",
    birth_day: "Birth day",
    birth_month: "День народження",
    cannot_be_delivered: "Не може бути доставлено",
    channel: "Канал",
    channels: "Канали",
    complex_status_changed: "Зміна статусу комплексу із плану лікування",
    create_mailing: "Створити розсилку",
    december: "Грудень",
    do_not_send_at_night_time: "Не відправляти вночі (22:00 - 07:00)",
    does_not_contain: "Не містить",
    duplicate: "Копіювати",
    february: "Лютий",
    given_time: "Заданий час",
    has_future_visit: "Є візит на майбутні дати",
    has_tags: "Має мітки",
    has_treatment_plan_with_status: "Має план лікування зі статусом",
    has_visit_with_status: "Має візит зі статусом",
    immediately_after_creating: "Відразу після створення",
    january: "Січень",
    july: "Липень",
    june: "Червень",
    laboratory_order_status: "Статус робочого наряду",
    laboratory_order_status_changed: "Зміна статусу замовлення",
    launch_mailing: "Запустити розсилку",
    mailing: "Розсилка",
    mailing_date: "Дата розсилки",
    mailing_report: "Звіт по розсилкам",
    mailings: "Розсилки",
    march: "Березень",
    marketing: "Маркетинг",
    marketing_mailing: "Розсилка",
    may: "Травень",
    no_push_token: "Відсутня токен",
    not_enough_balance: "Недостатньо коштів на рахунку",
    november: "Листопад",
    october: "Жовтень",
    of_days: "днів",
    of_hours: "годин",
    passed_since_last_visit: "Минуло з останнього візиту",
    payments_were: "Оплат було",
    plan_status_changed: "Змінено статус плану лікування",
    push_notification: "Push-повідомлення",
    push_notifications: "Push-повідомлення",
    ready: "Готово",
    retry: "Спробувати ще раз",
    same_day: "В той же день",
    save_filter: "Зберегти фільтр",
    send_again: "Надіслати повторно",
    send_date: "Дата відправки",
    send_info: "Інформація про відправку",
    sent_slash_error: "Відправлено / Помилка",
    september: "Вересень",
    since_last_visit: "Після останнього візиту",
    sms_message: "СМС-повідомлення",
    stop_mailing: "Зупинити розсилку",
    tags_for_marketing_mailing: "Теги для автоматичного виведення інформації:",
    task_title: "Назва завдання",
    time: "Час",
    token: "Токен",
    tokens: "Токени",
    too_many_attempts: "Занадто багато спроб відправлення",
    total_in_group: "Всього в групі",
    treatment_plan_created: "Створено новий план лікування",
    users_selected: "Обрано користувачів",
    visit_time_changed: "Час візиту перенесено",
    wrong_credentials: "Невірні авторизовані дані сервісу відправки",
    wrong_phone_number: "Невірний номер телефону"
}
